// extracted by mini-css-extract-plugin
export default {"error":"NewExpenseFormMessage_error__UQ5md","success":"NewExpenseFormMessage_success__FEvwl"};